<div class="container">

            <div class="card shadow-lg border-0 rounded-lg mt-5">
                <div class="card-header"><h3 class="text-center font-weight-light my-4">Recuperar clave</h3></div>
                <div class="card-body">
                    <div class="small mb-3 text-muted">Ingresa tu email y te enviaremos un vínculo para reinstaurar tu clave.</div>
                    <form>
                        <div class="form-group"><label class="small mb-1" for="inputEmailAddress">Email</label><input class="form-control py-4" id="inputEmailAddress" type="email" aria-describedby="emailHelp" placeholder="Ingresa email" /></div>
                        <div class="form-group d-flex align-items-center justify-content-between mt-4 mb-0"><a class="btn btn-primary" routerLink="/auth/login">Cambiar mi clave</a></div>
                    </form>
                </div>
                <div class="card-footer text-center">
                    <!-- <div class="small"><a routerLink="/auth/register">Need an account? Sign up!</a></div> -->
                </div>
            </div>
</div>
